import React, { ReactNode } from 'react';
import classnames from 'classnames';
import { Activity, DataVendor, SearchQueryResponse } from 'v2/models';
import styles from './activityItem.module.scss';
import restFactory from 'v2/utils/restFactory';
import { useQuery } from 'react-query';
import { SearchActivityType } from 'v2/utils/activityUtils';
import ActivityItemDescription from './ActivityItemDescription';

interface ActivityItemProps {
  activity: Activity;
  render: (content: string) => ReactNode;
  canTruncateContent?: boolean;
  expanded: boolean;
  setExpanded: () => void;
  truncated: boolean;
  handleTruncate: (_truncated: boolean) => void;
}

const ActivityItemRequest = ({
  activity,
  render,
  expanded,
  setExpanded,
  truncated,
  handleTruncate,
}: ActivityItemProps) => {
  const searchId = activity.relationships.find(
    (relationship) => relationship.table_name === 'Searches'
  )?.object_id;

  const dataVendorId = activity.relationships.find(
    (relationship) => relationship.table_name === 'DataVendor'
  )?.object_id;

  const { data: searchData } = useQuery(
    [`ActivityItemRequest ${searchId} ${dataVendorId}`, activity.creator],
    async () =>
      await restFactory.get<SearchQueryResponse>(`/dj/api/v1/search/details/`, {
        id: searchId,
      }),
    {
      staleTime: Infinity,
      refetchOnMount: 'always',
    }
  );

  const { data: dataVendorData } = useQuery(
    [`ActivityItemDataVendor ${searchId} ${dataVendorId}`, activity.creator],
    async () =>
      await restFactory.get<DataVendor>(
        `/dj/api/v1/data_vendor/${dataVendorId}`
      ),
    { staleTime: Infinity, refetchOnMount: 'always' }
  );

  const dataVendorName = dataVendorData?.name || '';
  const requestName = searchData?.results?.[0]?.name || '';

  const getDescription = () => {
    if (activity.type === 'responded_to_request') {
      return activity.description;
    }
    const first_name = searchData?.results?.[0]?.submitted_by?.first_name || '';
    const last_name = searchData?.results?.[0]?.submitted_by?.last_name || '';
    const creatorName = `${first_name} ${last_name}`;
    return `${creatorName} ${
      SearchActivityType[activity.type] || activity.type
    } response from ${dataVendorName} for data request ${requestName}`;
  };

  return (
    <div className={classnames(styles.activityDescription)}>
      {activity.type === 'responded_to_request' && (
        <div className={styles.requestItem}>
          <span>
            Request: <span className={styles.name}>{requestName}</span>
          </span>
          <span>
            Data Provider: <span className={styles.name}>{dataVendorName}</span>
          </span>
        </div>
      )}
      <ActivityItemDescription
        content={getDescription()}
        render={render}
        expanded={expanded}
        setExpanded={setExpanded}
        truncated={truncated}
        handleTruncate={handleTruncate}
      />
    </div>
  );
};

export default ActivityItemRequest;
